import debounce from 'lodash/debounce';

export default class Filter {
	constructor ($filter) {
		this.$filter = $filter;
		this.$form = $filter.find('form');
		this.$preloader = $filter.find('[data-filter-preloader]');
		this.type = $filter.data('filter');
		this.locationPathName = window.location.pathname;
		this.route = window.projectConfig.route.ajax.filter[this.type];
		this.link = null;
		this.$allBoxes = $filter.find('[data-name-filter]');
		this.$submit = $filter.find('[data-filter-action="submit"]');
		this.$showAnotherView = $filter.find('[data-filter-action="another-view"]');
		this.$clearFilter = $filter.find('[data-filter-action="clear-filter"]');
		this.norerederfiel = null;

		this.init();
	}

	init () {
		this.addListeners();
	}

	addListeners () {
		var _this = this;

		if (this.type === 'progress') {
			this.$allBoxes.filter('[data-route]').on('click change', 'input', (e) => {
				let $currentBox = $(e.delegateTarget);
				let $currentInput = $(e.currentTarget);
				let route = $currentBox.data('route');
				let params = {
					id: $currentBox.closest('[data-complex-id]').data('complex-id')
				};

				params[$currentBox.data('name-filter')] = $currentInput.val();

				$.post(route, params).then((response) => {
					this.render(response);
				});
			});
		} else if (this.type === 'layout') {
			this.$filter.on('input', 'input[data-type="field"]', debounce(() => {
				this.preloader('show');
				this.request().then((response) => {
					this.renderContent(response);
					this.preloader('hide');
				});
			}, 1000));

			this.$filter.on('change', 'input[data-type="checker"]', (e) => {
				_this.norerederfiel = e.target.closest('[data-name-filter]').getAttribute('data-name-filter');
				this.preloader('show');
				this.request().then((response) => {
					this.renderContent(response);
					this.preloader('hide');
				});
			});
		} else if (this.type === 'construction') {
			this.$filter.on('input', 'input[data-type="field"]', debounce(() => {
				this.preloader('show');
				this.request().then((response) => {
					this.renderContent(response);
					this.preloader('hide');
				});
			}, 1000));

			this.$filter.on('change', 'input[data-type="checker"]', (e) => {
				_this.norerederfiel = e.target.closest('[data-name-filter]').getAttribute('data-name-filter');
				this.preloader('show');
				this.request().then((response) => {
					this.renderContent(response);
					this.preloader('hide');
				});
			});

			$('#filter-content').on('change', '[data-progress-button]', () => {
				this.preloader('show');
				this.request().then((response) => {
					this.renderContent(response);
					this.preloader('hide');
				});
			});
		} else {
			this.$filter.on('change', 'input[data-type="checker"]', (e) => {
				_this.norerederfiel = e.target.closest('[data-name-filter]').getAttribute('data-name-filter');
				this.preloader('show');
				this.request().then((response) => {
					this.render(response);
					this.updateSummary(response);
					this.preloader('hide');
				});
			});

			this.$filter.on('input', 'input[data-type="field"]', debounce(() => {
				this.preloader('show');
				this.request().then((response) => {
					this.render(response);
					this.updateSummary(response);
					this.preloader('hide');
				});
			}, 1000));

			this.$form.on('submit', (e) => {
				e.preventDefault();

				if (this.link) {
					window.location.href = this.link;
				}
			});
		}
	}

	renderContent (response) {
		const $roomInputs = this.$filter.find('[data-room]');
		const $houseInputs = this.$filter.find('[data-layout-filter-control="home"]');
		const $dateInputs = this.$filter.find('[data-layout-filter-control="date"]');

		if (response.activeDate) {
			const $dateSelect = $('#select_date');
			const activeOption = $dateInputs.filter(`[value="${response.activeDate}"]`);
			activeOption.prop('checked', true);
			let updateBox = $dateSelect.data('updateBox');
			updateBox($dateSelect);
		}

		const activeCheckboxes = {
			house: Object.values(response.isset_home_name)
		};

		if (response.isset_count_room) {
			$.extend(activeCheckboxes, {
				room: Object.values(response.isset_count_room)
			});
			this.sortCheckboxes($roomInputs, activeCheckboxes.room);
		}

		if (response.isset_dates) {
			$.extend(activeCheckboxes, {
				dates: Object.values(response.isset_dates)
			});
			this.sortCheckboxes($dateInputs, activeCheckboxes.dates);
		}

		this.sortCheckboxes($houseInputs, activeCheckboxes.house);

		if (!response.html.length) {
			console.error('Что-то пошло не так');
			return;
		}

		const $totalMetering = this.$filter.find('[data-layout-filter-control="totalMetering"]');
		const $kitchenMetering = this.$filter.find('[data-layout-filter-control="kitchenMetering"]');

		if ($totalMetering.length && $kitchenMetering.length) {
			const $totalInstance = $totalMetering.data('ionRangeSlider');
			const $kitchenInstance = $kitchenMetering.data('ionRangeSlider');
			this.$filter.find('[data-total-min]').text(response.min_area);
			this.$filter.find('[data-total-max]').text(response.max_area);
			this.$filter.find('[data-kitchen-min]').text(response.min_kitchen);
			this.$filter.find('[data-kitchen-max]').text(response.max_kitchen);

			$totalInstance.update({
				from: response.min_area,
				to: response.max_area
			});

			$kitchenInstance.update({
				from: response.min_kitchen,
				to: response.max_kitchen
			});
		}

		const $contentContainer = $('#filter-content');
		$contentContainer.html(response.html);
		const $jsInits = $contentContainer.find('.js-init');
		const $favoriteTriggers = $jsInits.filter('[data-favorites]');
		let $sliders = $jsInits.filter('[data-slider]');
		let $videos = $jsInits.filter('[data-video-preview]');

		if ($favoriteTriggers.length) {
			import('../_modules/favorites').then(module => {
				module.default($favoriteTriggers);
			});
		}

		if ($contentContainer.find('.js-mfp-gallery').length) {
			import('../_modules/mfp/mfp-gallery').then(module => {
				module.default();
			});
		}

		if ($contentContainer.find('.lozad').length) {
			import('../_modules/lazy-load').then(module => {
				module.init($);
			});
		}
		if ($sliders.length) {
			import('../_modules/slider').then(module => {
				module.default($sliders.toArray());
			});
		}

		if ($videos.length) {
			import('../_modules/video-preview').then(({videoPreview}) => {
				videoPreview($videos);
			});
		}
	}

	setRadio ($inputs, values) {
		$inputs.each((i, el) => {
			const $el = $(el);
			const value = $el.val();

			if (values.includes(value)) {
				this.setRadioActive($el);
			} else {
				this.setRadioInactive($el);
			}
		});
	}

	setRadioActive ($input) {
		const $label = $input.closest('label');
		$label.addClass('is-active');
	}

	setRadioInactive ($input) {
		const $label = $input.closest('label');
		$label.removeClass('is-active');
	}

	sortCheckboxes ($inputs, values) {
		$inputs.each((i, el) => {
			const $el = $(el);
			const $label = $el.closest('label');
			const value = $el.val();

			if ($el.is(':checked')) {
				$label.addClass('is-active');
			} else {
				$label.removeClass('is-active');
			}

			if (values.includes(value)) {
				this.setCheckboxActive($el);
			} else {
				this.blockCheckbox($el);
			}
		});
	}

	blockCheckbox ($input) {
		const $label = $input.closest('label');
		$input.prop({ 'disabled': true, 'checked': false });
		$label.addClass('is-disabled');
	}

	setCheckboxActive ($input) {
		const $label = $input.closest('label');
		$input.prop('disabled', false);
		$label.removeClass('is-disabled');
	}

	collectData () {
		/* eslint-disable no-undef */
		const data = new FormData(this.$form.get(0));
		return data;
	}

	request () {
		let _self = this;
		return $.ajax({
			url: _self.route,
			type: 'POST',
			data: _self.collectData(),
			dataType: 'JSON',
			processData: false,
			contentType: false
		})
			.done((response) => {
			})
			.fail((err) => {
				console.warn(err);
				_self.preloader('hide');
			})
			.always((response) => {
			});
	}

	render (response) {
		const $total = $('.js-zhk-current-number');
		const $nearmetro = $('[data-name-filter="nearmetro"]');
		const $installment = $('[data-name-filter="installment"]');
		const $credit = $('[data-name-filter="credit"]');

		if (response.currentCount) {
			$total.text(response.currentCount);
		}

		if (response.nearmetro) {
			$nearmetro.removeClass('is-disabled');
		} else {
			$nearmetro.addClass('is-disabled');
		}

		if (response.individual_credit) {
			$installment.removeClass('is-disabled');
		} else {
			$installment.addClass('is-disabled');
		}

		if (response.credit) {
			$credit.removeClass('is-disabled');
		} else {
			$credit.addClass('is-disabled');
		}

		Object.keys(response.filter).forEach((key) => {
			if (/^price$/i.test(key)) {
				let $filterBlock = this.$allBoxes.filter(`[data-name-filter="${key}"]`);
				let price = response.filter[key];

				$filterBlock.find('[name="minprice"]').val(price.from);
				$filterBlock.find('[name="maxprice"]').val(price.to);
			} else if (/^metering$/i.test(key)) {
				let $filterBlock = this.$allBoxes.filter(`[data-name-filter="${key}"]`);
				let metering = response.filter[key];

				$filterBlock.find('[name="minarea"]').val(metering.from);
				$filterBlock.find('[name="maxarea"]').val(metering.to);
			} else if (/^komnaty$/i.test(key) || /^year$/i.test(key)) {
				let $filterBlock = this.$allBoxes.filter(`[data-name-filter="${key}"]`);
				let $checkboxes = $filterBlock.find(`[name="${key}[]"]`);
				let data = response.filter[key];
				$checkboxes.parent().removeClass('is-disabled');
				data.forEach((item) => {
					if (item.disabled) {
						$checkboxes.filter(`[value="${item.value}"]`).parent().addClass('is-disabled');
					}
				});
			} else if (/^top_builders$/i.test(key)) {
				let $filterBlock = this.$allBoxes.filter('[data-name-filter="builders"]');
				let $checkboxes = $filterBlock.find('[data-multiselect-input]');
				let data = response.filter[key];
				$checkboxes.parent().removeClass('is-disabled');
				data.forEach((item) => {
					if (item.disabled) {
						$checkboxes.filter(`[value="${item.value}"]`).parent().addClass('is-disabled');
					}
				});
			} else {
				let $box = this.$allBoxes.filter(`[data-name-filter="${key}"]`).find('[data-select-box]');
				let data = response.filter[key];
				let $boxList = $box.find('.select-box__list');
				let newItems = [];

				if (data && data.length) {
					let $boxItem = $box.find('.select-box__item').first().detach();
					$box.removeClass('is-disabled');

					data.forEach((item) => {
						let $tplItem = $boxItem.clone(true, true);
						let $tplItemInput = $tplItem.find('.control__field');
						let $tplItemText = $tplItem.find('.control__text');
						let isCurrent = !!item.checked;
						let isDisabled = !!item.disabled;
						let isBold = !!item.bold;
						let filter = $('[data-filter="main"]');

						$tplItem.find('.control').removeClass('is-disabled');
						$tplItem.removeClass('is-disabled');
						filter.find('.is-bold').removeClass('is-bold');
						$tplItemInput.removeAttr('disabled').removeAttr('checked').prop('checked', false).prop('disabled', false);

						$tplItem.toggleClass('is-disabled', isDisabled);
						$tplItemInput.val(item.value).prop('checked', isCurrent).prop('disabled', isDisabled);

						if (isCurrent) {
							$tplItem.addClass('is-active');
						}

						if (isBold) {
							$tplItem.addClass('is-bold');
						}

						if ($box.hasClass('select-box--single') && !isDisabled) {
							$tplItem.toggleClass('is-disabled', isCurrent);
						}

						$tplItemText.text(item.name);
						newItems.push($tplItem);
					});

					$boxList.empty().append(newItems);
					$box.data('updateBox')($box, 'filter');
				} else {
					$box.addClass('is-disabled');
					$box.data('resetBox')($box, 'filter');
				}
			}
		});
	}

	preloader (action = null) {
		if (!action) {
			return;
		}

		let timeout = null;

		if (action === 'show') {
			this.$form.addClass('is-disabled');

			if (this.$preloader.length) {
				this.$preloader.addClass('is-shown');
			}
		} else if (action === 'hide') {
			window.clearTimeout(timeout);

			timeout = setTimeout(() => {
				this.$form.removeClass('is-disabled');

				if (this.$preloader.length) {
					this.$preloader.removeClass('is-shown');
				}
			}, 1000);
		}
	}

	updateSummary (oInfo = null) {
		if (!oInfo) {
			return;
		}

		// this.$submit.addClass('has-result');

		if (oInfo.count) {
			this.$submit.prop('disabled', false).removeClass('is-disabled').find('[data-filter-results]').html(oInfo.btnText);
			this.$showAnotherView.removeClass('is-disabled');
		} else {
			this.$submit.prop('disabled', true).addClass('is-disabled').find('[data-filter-results]').html(oInfo.btnText);
			this.$showAnotherView.addClass('is-disabled');
		}
		this.$clearFilter.attr('href', oInfo.link['clear']);
		if (/catalog/i.test(this.locationPathName)) {
			this.link = oInfo.link['catalog'];
			this.$showAnotherView.attr('href', oInfo.link['maps']);
		} else if (/map/i.test(this.locationPathName)) {
			this.link = oInfo.link['maps'];
			this.$showAnotherView.attr('href', oInfo.link['catalog']);
		}
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_classes/Filter.js